import React, { useState } from "react";

import { Button, styled } from "@mui/material";
import PlusIcon from "assets/icons/PlusIcon";
import BasicTextInput from "components/BasicInputs/BasicTextInput";
import CloseIcon from "assets/icons/CloseIcon";
import NoteIcon from "assets/svg/factorHistoryIcon/Note";
import EditIcon from "assets/svg/factorHistoryIcon/Edit";
import DeleteIcon from "assets/svg/factorHistoryIcon/Delete";
import SubmitIcon from "assets/svg/factorHistoryIcon/submit";
import { useDispatch } from "react-redux";
import { apiCreateNote, apiDeleteNote } from "api/noteApi";

const Box = styled("div")(() => ({
  minWidth: "435.570px",
  backgroundColor: "#fff",
  padding: 24,
}));
const Line = styled("div")(() => ({
  width: "1px",
  backgroundColor: "#CAD1DE",
  height: "32px",
  marginBottom: "8px",
  marginTop: "8px",
  marginRight: "16px",
}));

type Props = {
  token?: string;
  id?: string;
  detail_type?: string;
  noteList?: any;
  refresh?: () => void;
  history?: any;
  title?: string;
};

// const fakeData = [
//   {
//     createBy: "system",
//     id: 0,
//     title: "ثبت فاکتور",
//     description: "نام کاربر سیستم",
//     date: "۱۴۰۱/۱۲/۲۸ ۱۲:۳۴",
//     type: "submit",
//   },
//   {
//     createBy: "system",
//     id: 0,
//     title: "ویرایش فاکتور",
//     description: "نام کاربر سیستم",
//     date: "۱۴۰۱/۱۲/۲۸ ۱۲:۳۴",
//     type: "edit",
//   },
// ];

function DrawerHistory({ token, id, detail_type, noteList, refresh, history, title }: Props) {
  const [openNote, setOpenNote] = useState(false);
  const [note, setNote] = useState<string | number>("");

  const dispatch = useDispatch();

  const addNewNote = () => {
    dispatch(
      // @ts-ignore
      apiCreateNote(token, id, detail_type, note, () => {
        setOpenNote(false);
        refresh && refresh();
      })
    );
  };

  const deleteItem = (id: string) => {
    dispatch(
      // @ts-ignore
      apiDeleteNote(token, id, () => {
        refresh && refresh();
      })
    );
  };

  const renderIcon = (type: string) => {
    switch (type) {
      case "note":
        return <NoteIcon scale={0.8} color={openNote ? "#95A3B5" : "#D07E10"} />;
      case "edit":
        return <EditIcon scale={0.9} color={openNote ? "#95A3B5" : "#1062D0"} />;
      case "delete":
        return <DeleteIcon color={openNote ? "#95A3B5" : "#CB0B0B"} />;
      case "submit":
        return <SubmitIcon scale={0.8} color={openNote ? "#95A3B5" : "#1E8E1B"} />;

      default:
        break;
    }
  };

  return (
    <Box>
      <div
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {history.map((item: any, index: any) => (
          <div key={index}>
            <div
              style={{
                width: "100%",
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
              }}
            >
              <div>
                <div
                  style={{
                    backgroundColor: "#F5F9FF",
                    display: "flex",
                    width: "32px",
                    height: "32Px",
                    borderRadius: "16px",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {renderIcon(item.isEdit ? "edit" : "submit")}
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  marginRight: 16,
                }}
              >
                <div>
                  <span
                    style={{
                      fontSize: "14px",
                      color: "#576271",
                    }}
                  >
                    {item.isEdit ? "ویرایش" : "ثبت"} {title}
                  </span>
                </div>
                <div>
                  <span
                    style={{
                      fontSize: "12px",
                      color: "#8F8F8F",
                    }}
                  >
                    {item?.user?.name}
                  </span>
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  flex: 1,
                  justifyContent: "flex-end",
                }}
              >
                <span
                  style={{
                    fontSize: "12px",
                    color: "#8F8F8F",
                  }}
                >
                  {item.date}
                </span>
              </div>
            </div>
            {history?.length - 1 !== index && <Line />}
          </div>
        ))}
        {noteList?.length !== 0 && <Line />}
        {noteList.map((item: any, index: any) => (
          <div key={index}>
            <div
              style={{
                width: "100%",
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
              }}
            >
              <div>
                <div
                  style={{
                    backgroundColor: "#F5F9FF",
                    display: "flex",
                    width: "32px",
                    height: "32Px",
                    borderRadius: "16px",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {renderIcon("note")}
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  marginRight: 16,
                }}
              >
                <div>
                  <p
                    style={{
                      fontSize: "14px",
                      color: "#576271",
                      whiteSpace: "break-spaces",
                    }}
                  >
                    {item.text}
                  </p>
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  flex: 1,
                  justifyContent: "flex-end",
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                <span
                  style={{
                    fontSize: "12px",
                    color: "#8F8F8F",
                  }}
                >
                  {item?.date}
                </span>
                <div
                  style={{
                    padding: 2,
                    borderRadius: "20px",
                    backgroundColor: "#fff2f2",
                    marginRight: 12,
                  }}
                  onClick={() => deleteItem(item.id)}
                >
                  <DeleteIcon scale={0.6} />
                </div>
              </div>
            </div>
            {noteList?.length - 1 !== index && <Line />}
          </div>
        ))}
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          marginTop: "44px",
        }}
      >
        {openNote ? (
          <div
            style={{
              width: "100%",
            }}
          >
            <div
              style={{
                position: "relative",
                display: "flex",
                flexDirection: "row",
                width: "100%",
              }}
            >
              <div
                style={{
                  backgroundColor: "#F5F9FF",
                  display: "flex",
                  width: "32px",
                  height: "32Px",
                  borderRadius: "16px",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <NoteIcon scale={0.8} color="#1062D0" />
              </div>
              <div
                style={{
                  marginRight: 16,
                  width: "100%",
                }}
              >
                <BasicTextInput
                  textArea
                  rows={5}
                  placeHolder="متن یادداشت را وارد کنید"
                  style={{ flex: 1 }}
                  val={note}
                  onChange={setNote}
                />
              </div>
              <div
                onClick={() => setOpenNote(false)}
                style={{
                  borderRadius: 15,
                  background: "#E3E4E5",
                  position: "absolute",
                  top: -12,
                  left: -12,
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <CloseIcon scale={0.4} />
              </div>
            </div>
            <div
              style={{
                marginTop: "16px",
                paddingRight: "48px",
              }}
            >
              <Button
                variant="contained"
                onClick={() => {
                  addNewNote();
                }}
                style={{
                  padding: "10px 16px",
                  borderRadius: "6px",
                }}
              >
                <PlusIcon scale={0.5} color="#ffff" />

                <span>ثبت یادداشت</span>
              </Button>
            </div>
          </div>
        ) : (
          <div onClick={() => setOpenNote(true)}>
            <PlusIcon scale={0.5} />
            <span
              style={{
                color: "#1062D0",
                fontSize: "14px",
                marginRight: "8px",
              }}
            >
              ثبت یادداشت
            </span>
          </div>
        )}
      </div>
    </Box>
  );
}

export default DrawerHistory;
